__turbopack_context__.v({
  "dot1": "zPvr2G_dot1",
  "dot2": "zPvr2G_dot2",
  "dot4": "zPvr2G_dot4",
  "loaderDotFour": "zPvr2G_loaderDotFour",
  "loaderDotOne": "zPvr2G_loaderDotOne",
  "loaderDotThree": "zPvr2G_loaderDotThree",
  "loaderDotTwo": "zPvr2G_loaderDotTwo",
});
